import { Group } from "@mantine/core";
import { IconCircleCheckFilled, IconX } from "@tabler/icons-react";
import { useTranslation } from "react-i18next";

import { colors } from "#app/theme/v2/colors";
import { radius } from "#app/theme/v2/radius";
import { shadows } from "#app/theme/v2/shadows";
import { spacing } from "#app/theme/v2/spacing";

import { Button } from "../../atoms/Button/Button";
import { IconButton } from "../../atoms/IconButton/IconButton";
import { Text } from "../../atoms/Typographies/Text";

const TOASTER_ICON_SIZE = 16;

type ToasterType = "default" | "compact";

type ToasterProps = {
  message: string;
  type?: ToasterType;
  onCancel?: () => void;
  onClose?: () => void;
};

const Toaster = ({ message, type = "default", onCancel, onClose }: ToasterProps) => {
  const { t } = useTranslation("components");
  const isDefault = type === "default";

  return (
    <Group
      wrap="nowrap"
      align="center"
      gap={spacing[3]}
      p={spacing[3]}
      bg={colors.bg.elevation.primary}
      style={{
        borderRadius: radius.md,
        boxShadow: shadows.elevation3,
      }}
    >
      <Group
        wrap="nowrap"
        align="center"
        gap={spacing[2]}
        px={spacing[1]}
        py={spacing[1.5]}
        style={{ flex: "1 0 0", minWidth: 0 }}
      >
        {isDefault && (
          <IconCircleCheckFilled
            size={TOASTER_ICON_SIZE}
            color={colors.icon.success}
            style={{ flexShrink: 0 }}
          />
        )}
        <Text size="small" truncate>
          {message}
        </Text>
      </Group>
      {isDefault && onCancel && (
        <Button variant="secondary" size="sm" onClick={onCancel}>
          {t("toaster.cancel")}
        </Button>
      )}
      {!isDefault && onClose && (
        <IconButton variant="secondary" size="sm" aria-label={t("toaster.close")} onClick={onClose}>
          <IconX size={TOASTER_ICON_SIZE} />
        </IconButton>
      )}
    </Group>
  );
};

export { Toaster };
